const nodeEnv = process.env.NODE_ENV || "development";
const explicitApiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (nodeEnv === "production"
    ? process.env.REACT_APP_PROD_BACKEND_URL
    : process.env.REACT_APP_DEV_BACKEND_URL);
const fallbackDevBaseUrl = "http://localhost:5000";

export const apiBaseUrl =
  explicitApiBaseUrl || (nodeEnv === "production" ? "" : fallbackDevBaseUrl);
export const apiEnabled = Boolean(explicitApiBaseUrl) || nodeEnv !== "production";
